import styled from 'styled-components';

export const ContainerBody = styled.div`
    background-color: transparent;
    padding: 0px;
    display: flex;
    flex-direction: column;
`

export const Row = styled.div`
    background-color: transparent;
    padding: 0px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
`

export const RequiredHint = styled.div`
    color: #6c757d;
    font-size: 13px;
    margin-bottom: 8px;
`

export const ErrorList = styled.ul`
    color: #dc3545;
    font-size: 14px;
    margin: 10px 0px 0px 0px;
    padding-left: 18px;
`
